
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default {
  name: "EnvioContabilidadeEmailListInput",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "contador@example.com",
    },
    error: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      novoEmail: "",
      erroLocal: "",
    };
  },
  computed: {
    emails() {
      return Array.isArray(this.value) ? this.value : [];
    },
    invalidState() {
      return Boolean(this.erroLocal || this.error);
    },
  },
  methods: {
    adicionar() {
      const email = this.novoEmail.trim().toLowerCase();
      this.erroLocal = "";

      if (!email) {
        return;
      }

      if (!EMAIL_REGEX.test(email)) {
        this.erroLocal = "Informe um e-mail válido.";
        return;
      }

      if (this.emails.includes(email)) {
        this.erroLocal = "Este e-mail já foi adicionado.";
        return;
      }

      this.$emit("input", [...this.emails, email]);
      this.novoEmail = "";
    },
    remover(email) {
      this.$emit(
        "input",
        this.emails.filter(item => item !== email)
      );
    },
  },
};
